import axios from "axios";

export default function getCreditBalanceReloadLog(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/campaignV2/customer/company/balanceReloadLog`, {
        params: { limit: parameters.length, skip: parameters.start },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
